import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/icon-check-button/icon-check-button.js';
      

      export interface Props {
     checked?: boolean;
     disabled?: boolean;
     hasLabel?: boolean;
     label?: string;
     hasAlert?: boolean;
     externalControl?: boolean
   }

      
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcIconCheckButton',
  props: {
    checked: { type: Boolean },
    disabled: { type: Boolean },
    hasLabel: { type: Boolean },
    label: {},
    hasAlert: { type: Boolean },
    externalControl: { type: Boolean }
  },
  emits: ["icon-check-button-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onIconCheckButtonClick: (event: CustomEvent<{checked: boolean}>) => emit('icon-check-button-click', event as CustomEvent<{checked: boolean}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-icon-check-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})